var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationBlankstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "455px",
    viewBox: "0 0 88 455",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C84FD725-2C38-4AB0-9896-3593328A520F_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Blankstate",
    transform: "translate(-676.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration_Blankstate",
    transform: "translate(645.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,455.5 L102.565835,400.36833 C130.893058,343.713884 119.789272,275.289272 75,230.5 L75,230.5 C30.2107282,185.710728 19.1069422,117.286116 47.4341649,60.6316702 L75,5.5",
    id: "Path-10",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeDasharray: "8,8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.086544, 0.441893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.413456, 5.058107) rotate(15.000000) translate(-10.413456, -5.058107) translate(0.913456, 2.558107)",
    fill: "#FFFFFF",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    cx: 4,
    cy: 2.5,
    rx: 4,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 15,
    cy: 2.5,
    rx: 4,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D9D9D9",
    cx: 10.413456,
    cy: 5.05810746,
    r: 3.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationBlankstate);
export default __webpack_public_path__ + "static/media/Illustration_Blankstate.c87f7f8bf1490677d686d94013d90b54.svg";
export { ForwardRef as ReactComponent };